export default "__VITE_ASSET__7P0loDAJ__"